import { InteractionStatus } from "@azure/msal-browser";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useAccount,
  useIsAuthenticated,
  useMsal,
  useMsalAuthentication,

} from "@azure/msal-react";
import { GlobalTheme, Loading, Theme } from "@carbon/react";
import { GlobalContext } from "ContextApi/GlobalContext";
import {
  Useraccesstoken,
  countFetch,
  handlePageChangedata,
  user_signup,
} from "Globaldata";
import { datareducer, intitialState } from "Reducer/Reducer";
import { loginRequest, msalConfig, silentRequest } from "authConfig";
import axios from "axios";
import { ThemeProvider } from "components/ThemeProvider";
import Header from "components/header";
import Layout from "components/layout";
import FullScreenModal from "components/modal/fullScreenModal";
import ThemeModal from "components/modal/themeModal";
import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { initWebchat } from "redux/reducers/actions/initWebChat";
import { getAllticketData } from "redux/slices/Alltickets/allticketSlice";
import {
  getAllNotifications,
  getDisturbData,
  getUnseenNotifications,
} from "redux/slices/Notifications/NotificationsSlice";
import { GetArticals } from "redux/slices/RecommendArticals/RecommendSlice";
import { getSalesForceData } from "redux/slices/SalesForce/SalesForceSlice";
import { getExistingSubcriptions } from "redux/slices/Subscriptions/SubscriptionsSlice";
import { getSupportTickets } from "redux/slices/Support/SupportSlice";
import { getalluserData } from "redux/slices/UserSlice/UserAlldataSlice";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { initLogger } from "utils/logger";
import { privateRoutes } from "utils/routes/privateRoutes";
import MobileHeaderNav from "components/sidenav/mobileNav/mobileHeaderNav";
import { useThemeDetector } from "isdarkthemFavicon";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./App.scss";
import { GetFilterOptions } from "redux/slices/TraningGuidens/TrainingGuidensSlice";
import { socket, useSocket } from "./socket";

export const Contextprovider = createContext();

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

const App = () => {
     const { login, result, error } = useMsalAuthentication();

  const { instance, inProgress, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const context = useContext(GlobalContext);
  const isAuthenticated = useIsAuthenticated();
  const reduxDispatch = useDispatch();
  const { data } = useSelector((state) => state.user.data);
  const [useralldata, dispatch] = useReducer(datareducer, intitialState);
  const [authorizaion, setauthorizaion] = useState(false);
  const [loading, setLoading] = useState(true);

 
  useEffect(() => {
    if ( account) {
      reduxDispatch(getalluserData(account?.idTokenClaims?.sub));
    }
  }, [ account]);

  useEffect(() => {
    reduxDispatch(GetFilterOptions());
  }, []);
   useEffect(() => {
    try {
      if (!isAuthenticated && inProgress === InteractionStatus.None) {
        instance.loginRedirect(loginRequest);
      } else if (isAuthenticated && accounts) {
        instance.acquireTokenSilent({
          ...silentRequest,
          account: accounts[0],
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [isAuthenticated, inProgress, accounts, instance]);
  useEffect(() => {
    if (data) {
      dispatch({
        type: "USER_SIGNIN_LOGS",
        payload: {
          userid: data?.azure_id,
          fullname: `${data?.name}${" "}${data?.last_name}`,
          email: data?.email,
          phone: data?.phoneNumber,
          country: data?.country,
          address: data?.address,
          city: data?.city,
          state: data?.state,
          postalCode: data?.postalCode,
          companyName: data?.company_name,
          AccountId: data?.account_id,
          ProfileImage: data?.profile_img,
        },
      });
    }
  }, [data]);

  useEffect(() => {
    reduxDispatch(getDisturbData());
    // reduxDispatch(getAllticketData());
    // reduxDispatch(getSalesForceData());
    reduxDispatch(getUnseenNotifications());
    reduxDispatch(getAllNotifications());
    reduxDispatch(
      getSupportTickets({
        email: account?.idTokenClaims?.email,
        pageNumber: 1,
      })
    );
  }, []);

 


  useEffect(() => {
    if (!account) return;

    const urlParams = new URLSearchParams(window.location.search);

    initLogger("info");

    initWebchat({
      serverUrl:`${process.env.REACT_APP_NOTIFICATION_URL}/public`,
      deploymentKey: urlParams.get("deploymentKey") || "",
      region: urlParams.get("region") || "US1",
      theme: {
        isLight: true,
      },
    });

    reduxDispatch(getExistingSubcriptions(account?.idTokenClaims?.sub));
  }, [account]);




  useEffect(() => {
    if (useralldata?.userinfo?.email) {
      countFetch(useralldata, dispatch);
    }
  }, [
    useralldata?.TablePagination.per_page,
    useralldata?.TablePagination.page,
    useralldata?.TablePagination.widget_page,
    useralldata?.TablePagination.widget_per_page,
    useralldata?.Fillter.applyFilter,
    useralldata?.Fillter.search,
    useralldata?.userinfo?.email,
    useralldata?.Paginationloading,
  ]);

  useEffect(() => {
    if ( account) {
      user_signup(accounts, account);
    }
  }, [account]);

  useEffect(() => {
    if (account ) {
      handlePageChangedata(account, dispatch);
    }
  }, [account]);

 

  useEffect(() => {
    if (context?.globalTheme === "g100") {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "g100");
    } else {
      document.body.classList.remove("dark");
      localStorage.setItem("theme", "white");
    }
  }, [context?.globalTheme]);

  
 useSocket()

  const isDarkTheme = useThemeDetector();

  return (
    <ThemeProvider>

        <>
          <Helmet>
            <link
              rel="shortcut icon"
              href={
                isDarkTheme
                ? "https://cdn.uvation.com/identity/image/logo.png"
                : "https://cdn.uvation.com/identity/image/favicon.png"
              }
            />
          </Helmet>
          <Contextprovider.Provider value={{ useralldata, dispatch }}>
            {/* <GlobalProvider> */}
            <GlobalTheme theme={context?.globalTheme}>
              <Theme theme={context?.globalTheme}>
                <SCThemeProvider theme={{ colorScheme: context?.globalTheme }}>
                  <BrowserRouter>
                    <Header />
                    <ToastContainer />
                    <ScrollToTop />
                    <MobileHeaderNav />
                    <ThemeModal />
                    <FullScreenModal />

                    <Routes>
                      <Route
                        element={
                          <Layout>
                            <Outlet />
                          </Layout>
                        }
                      >
                        {privateRoutes.map((privateRouteDetail) => {
                          return (
                            <Route
                              exact
                              path="/"
                              element={<Outlet />}
                              key={privateRouteDetail.id}
                            >
                              <Route
                                exact
                                path={privateRouteDetail.path}
                                element={<privateRouteDetail.component />}
                              />
                            </Route>
                          );
                        })}
                      </Route>
                    </Routes>
                  </BrowserRouter>
                </SCThemeProvider>
              </Theme>
            </GlobalTheme>
            {/* </GlobalProvider> */}
          </Contextprovider.Provider>
        </>
     
    </ThemeProvider>
  );
};

export default App;
